import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSendInvitation = () => {
  return apiClient.invitation.sendInvite.useMutation({
    onSuccess: () => {
      toast.success('Forwarder successfully invited!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Failed to invite forwarder');
    },
  });
};
